export const SEASON_START_BATHROOM_PATH = '/promo/pora-pora-dom-vannaya/';

export const SEASON_START_BATHROOM_ELEMENT_BLOCK = 'landingStartSezonaVannaya';

export const SEASON_START_BATHROOM_CDN_PATH = 'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/season-start-bathroom';

export const SEASON_START_BATHROOM_LANDING_NAME = 'season-start-bathroom';

export const SEASON_START_BATHROOM_PRODUCTS = [
  {
    link: {
      href: '/offer/pora-pora-za-mezhkomnatnymi-dveryami-po-supercenam',
      title: 'Межкомнатные двери с установкой',
    },
    img: {
      alt: 'Баннер Межкомнатные двери с установкой',
      srcD: `${SEASON_START_BATHROOM_CDN_PATH}/banners/interior-doors-banner-ld.jpg/interior-doors-banner-ld-03.jpg`,
      srcT: `${SEASON_START_BATHROOM_CDN_PATH}/banners/interior-doors-banner-t.jpg/interior-doors-banner-t-03.jpg`,
      src: `${SEASON_START_BATHROOM_CDN_PATH}/banners/interior-doors-banner-m.jpg/interior-doors-banner-m-03.jpg`,
    }
  },
  {
    link: {
      href: '/offer/pora-pora-za-vodonagrevatelyami-po-supercenam',
      title: 'Водонагреватели с установкой',
    },
    img: {
      alt: 'Баннер Водонагреватели с установкой',
      srcD: `${SEASON_START_BATHROOM_CDN_PATH}/banners/water-heaters-banner-ld.jpg/water-heaters-banner-ld.jpg`,
      srcT: `${SEASON_START_BATHROOM_CDN_PATH}/banners/water-heaters-banner-t.jpg/water-heaters-banner-t.jpg`,
      src: `${SEASON_START_BATHROOM_CDN_PATH}/banners/water-heaters-banner-m.jpg/water-heaters-banner-m.jpg`,
    }
  },
  {
    link: {
      href: '/offer/pora-pora-za-keramogranitom-po-supercenam',
      title: 'Керамогранит с укладкой',
    },
    img: {
      alt: 'Баннер Керамогранит с укладкой',
      srcD: `${SEASON_START_BATHROOM_CDN_PATH}/banners/porcelain-stoneware-banner-ld.jpg/porcelain-stoneware-banner-ld.jpg`,
      srcT: `${SEASON_START_BATHROOM_CDN_PATH}/banners/porcelain-stoneware-banner-t.jpg/porcelain-stoneware-banner-t.jpg`,
      src: `${SEASON_START_BATHROOM_CDN_PATH}/banners/porcelain-stoneware-banner-m.jpg/porcelain-stoneware-banner-m.jpg`,
    }
  },
  {
    link: {
      href: '/offer/pora-pora-za-dushevymi-kabinami-po-supercenam',
      title: 'Душевые кабины с установкой',
    },
    img: {
      alt: 'Баннер Душевые кабины с установкой',
      srcD: `${SEASON_START_BATHROOM_CDN_PATH}/banners/shower-cabins-banner-ld.jpg/shower-cabins-baner-ld.jpg`,
      srcT: `${SEASON_START_BATHROOM_CDN_PATH}/banners/shower-cabins-banner-t.jpg/shower-cabins-banner-t.jpg`,
      src: `${SEASON_START_BATHROOM_CDN_PATH}/banners/shower-cabins-banner-m.jpg/shower-cabins-banner-m.jpg`,
    }
  }
];

export const SEASON_START_BATHROOM_SOLUTIONS = [
  {
    link: {
      href: '/promo/pora-pora-stroitelstvo/',
      title: 'Поможем построить',
    },
    img: {
      alt: 'Баннер Поможем построить',
      srcD: `${SEASON_START_BATHROOM_CDN_PATH}/banners/construction-banner-ld.jpg/construction-banner-ld-01.jpg`,
      srcT: `${SEASON_START_BATHROOM_CDN_PATH}/banners/construction-banner-t.jpg/construction-banner-t-01.jpg`,
      src: `${SEASON_START_BATHROOM_CDN_PATH}/banners/construction-banner-m.jpg/construction-banner-m-01.jpg`,
    }
  },
  {
    link: {
      href: '/promo/pora-pora-uchastok/',
      title: 'Облагородим участок',
    },
    img: {
      alt: 'Баннер Облагородим участок',
      srcD: `${SEASON_START_BATHROOM_CDN_PATH}/banners/plot-banner-ld.jpg/plot-banner-ld-01.jpg`,
      srcT: `${SEASON_START_BATHROOM_CDN_PATH}/banners/plot-banner-t.jpg/plot-banner-t-01.jpg`,
      src: `${SEASON_START_BATHROOM_CDN_PATH}/banners/plot-banner-m.jpg/plot-banner-m-01.jpg`,
    }
  },
];

export const SEASON_START_BATHROOM_COLLECTION_LIST = [
  {
    discount: 0.1,
    productId: 30008909,
    title: 'Набор Milk',
    description: '4 товара',
    img: {
      src: `${SEASON_START_BATHROOM_CDN_PATH}/collections/milk.jpg/milk-01.jpg`,
      alt: 'Фото комплекта Милк',
    },
    href: '/promo/nabory-mebeli-dlya-vannoy/nabor-mebeli-milk-gloriya/',
  },
  {
    discount: 0.1,
    productId: 30008911,
    title: 'Набор «Терни»',
    description: '4 товара',
    img: {
      src: `${SEASON_START_BATHROOM_CDN_PATH}/collections/terni.jpg/terni-01.jpg`,
      alt: 'Фото комплекта Терни',
    },
    href: '/promo/nabory-mebeli-dlya-vannoy/nabor-mebeli-terni-levaya/',
  },
  {
    discount: 0.1,
    productId: 30008913,
    title: 'Набор Black',
    description: '2 товара',
    img: {
      src: `${SEASON_START_BATHROOM_CDN_PATH}/collections/black.jpg/black-01.jpg`,
      alt: 'Фото комплекта Блэк',
    },
    href: '/promo/nabory-mebeli-dlya-vannoy/nabor-dlya-dushevoy-kvadrat-80x80-kvadro-black/',
  },
  {
    discount: 0.1,
    productId: 30008914,
    title: 'Набор «Квадро»',
    description: '2 товара',
    img: {
      src: `${SEASON_START_BATHROOM_CDN_PATH}/collections/square.jpg/square-01.jpg`,
      alt: 'Фото комплекта Квадро',
    },
    href: '/promo/nabory-mebeli-dlya-vannoy/nabor-dlya-dushevoy-kvadrat-90x90-kvadro-hrom/',
  }
];
